interface Experiments {
  /** A/B test for the onboarding 'guide' step — guide modal vs quick tour */
  "onboarding-guide": "tour" | "control";
}

export type ExperimentId = keyof Experiments;
export type ExperimentVariant<T extends ExperimentId> = Experiments[T];

const allVariants: { [K in ExperimentId]: ReadonlyArray<ExperimentVariant<K>> } = {
  "onboarding-guide": ["tour", "control"],
};

export function isValidVariant<T extends ExperimentId>(
  experimentName: T,
  value: unknown,
): value is ExperimentVariant<T> {
  return (
    typeof value === "string" && allVariants[experimentName].includes(value as ExperimentVariant<T>)
  );
}
